import { VStack } from '@talos/kyoko';
import styled from 'styled-components';

export const BuyingPowerRow = styled(VStack)`
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  padding: ${({ theme }) => `${theme.spacing4}px ${theme.spacing8}px`};
`;
